export const USER_STORAGE_KEY = 'edu-admin-application';

export const APP_API_URL =
  process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
    ? process.env.REACT_APP_STAGING_API_URL || ''
    : process.env.REACT_APP_PROD_API_URL || '';
